import { ReactNode } from 'react'
import { Table, TableBody } from '@mui/material'

interface StoreyControlsTableProps {
  children: ReactNode
}

const StoreyControlsTable = ({ children }: StoreyControlsTableProps) => (
  <Table
    size="small"
    sx={{
      borderCollapse: 'collapse',
      '& .MuiTableCell-root': {
        borderBottom: 'none',
      },
      // Size to content (the widest row) so the column doesn't leave whitespace to its right.
      width: 'auto',
    }}
  >
    <TableBody>{children}</TableBody>
  </Table>
)

export default StoreyControlsTable
